import { render, staticRenderFns } from "./lookWinInfo.vue?vue&type=template&id=a44889b0&scoped=true&"
import script from "./lookWinInfo.vue?vue&type=script&lang=js&"
export * from "./lookWinInfo.vue?vue&type=script&lang=js&"
import style0 from "./lookWinInfo.vue?vue&type=style&index=0&id=a44889b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44889b0",
  null
  
)

export default component.exports